var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/LastEdit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/LastEdit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Last-Edited",
    transform: "translate(4.000000, 2.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0533157,9.41396058 L15.9916794,10.3519021 L8.91334442,17.4288569 L7.9748503,16.4905457 L15.0533157,9.41396058 Z",
    id: "Combined-Shape",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.407834, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.94391472,0.499999305 C6.21857664,0.502123859 7.35511009,0.996459703 8.17440141,1.79783635 C8.99672701,2.60218093 9.49852448,3.71518146 9.49852448,4.9432702 C9.49852448,6.1679991 8.99983816,7.27841988 8.19495856,8.08272261 C7.39002548,8.88707877 6.27870565,9.38544306 5.05329925,9.3854433 C3.77962586,9.38418915 2.64346579,8.89005088 1.82429471,8.08863812 C1.00198943,7.28415909 0.5,6.17070612 0.5,4.94217286 C0.5,3.71737102 0.998503921,2.60687866 1.80324746,1.80255424 C2.60792844,0.998292334 3.71894941,0.5 4.94391472,0.499999305 Z M4.92447985,0.751826612 C3.77775348,0.752377884 2.73302017,1.22331324 1.97589877,1.98448716 C1.22152209,2.74290168 0.753075504,3.78901092 0.75362488,4.9423432 C0.754179395,6.10544543 1.23051489,7.15975114 2.01391226,7.92050266 C2.78316693,8.66752029 3.84965282,9.1323835 5.05375457,9.1323835 C6.20924623,9.1323835 7.25739649,8.66256728 8.01659032,7.90376884 C8.77588298,7.14487163 9.24595595,6.09711895 9.24595595,4.94210503 C9.24595595,3.77761571 8.76863049,2.72241541 7.98049665,1.96138408 C7.20907056,1.21648595 6.1384128,0.752369919 4.92447985,0.751826612 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.11138697,18.5286177 L0,18.5286177 L0,12.9906229 C0.243252573,11.9077318 0.797072079,11.3662863 1.66145852,11.3662863 C2.52584496,11.3662863 4.88033067,11.3662863 8.72491565,11.3662863 C9.35920022,11.3662863 9.85293508,11.5358576 10.2061202,11.875",
    id: "Path-17",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-18",
    fill: "#B7844D",
    points: "9.40762408 22 9.99358865 19.0572354 12.3464592 21.4096472"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/EditUser.10543ccc72dd876ef1a96088d8e8b1f1.svg";
export { ForwardRef as ReactComponent };